import React from 'react';
import { Box } from '@mui/material';
import {
  RecentChatsResponse,
  useGetRecentChatsQuery
} from '@features/chat/queries/ChatQueries';
import { FloatingButton } from '@components/floating-button/FloatingButton';
import { useNavigate } from 'react-router-dom';

const ChatTop: React.FC = () => {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const { data: chatsResponse } = useGetRecentChatsQuery(undefined, {
    selectFromResult: ({ data, ...rest }) => ({
      data: data as RecentChatsResponse | undefined,
      ...rest
    })
  });

  const hasUnread = chatsResponse?.data?.hasUnread ?? false;
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 10,
        right: 24,
        display: 'flex',
        flexDirection: 'row-reverse',
        gap: 2,
        alignItems: 'flex-end',
        zIndex: 1000,
        '& > *:not(:last-child)': {
          marginRight: 16
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
          gap: 2
        }}
      >
        {window.location.pathname !== '/chat' && (
          <FloatingButton
            onClick={() => navigate('/chat')}
            hasUnread={hasUnread}
          />
        )}
      </Box>
    </Box>
  );
};

export default ChatTop;
